import Toggle from "@/ui/Toggle";
import SeccionLayout, { BloqueSeccion, PieGuardar } from "../SeccionLayout";
import { AYUDA_SECCION } from "@/components/ayuda/vistas/configuracion";
import { useAppSettings, useBorradorSeccion } from "../useAppSettings";

/**
 * Los dos avisos que el sistema manda solo, todos los días, al equipo.
 *
 * Ninguno de los dos le escribe al cliente: son avisos internos.
 */
export default function AvisosProgramados() {
  const { settings, cargando, guardando, guardar, alternar } = useAppSettings();
  const { valores, set, sucio } = useBorradorSeccion(settings, (s) => ({
    digest_hora: s.digest_hora,
    aviso_cliente_hora: s.aviso_cliente_hora,
  }));

  if (cargando || !settings || !valores) {
    return <p className="text-sm text-zinc-500">Cargando…</p>;
  }

  return (
    <SeccionLayout
      ayuda={AYUDA_SECCION["avisos"]}
      ancho="formulario"
      titulo="Avisos programados"
      descripcion="Los avisos que salen solos cada día. Los switches se aplican al momento; las horas se guardan con el botón."
    >
      <div className="card space-y-4">
        <BloqueSeccion
          titulo="Resumen diario de casos sin seguimiento"
          descripcion="Cada día, a la hora indicada, cada quien recibe por correo y por Telegram —si lo tiene vinculado— la lista de sus casos que ya cruzaron el umbral amarillo. Los casos sin asignar van en el resumen de los administradores."
        >
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <Toggle
              checked={settings.digest_activo}
              onChange={(v) =>
                void alternar(
                  "digest_activo",
                  v,
                  v ? "Resumen diario encendido" : "Resumen diario apagado",
                )
              }
              label="Enviar resumen diario"
            />
            <label className="flex items-center gap-2 text-xs text-zinc-400">
              <span>a las</span>
              <input
                type="time"
                value={valores.digest_hora}
                onChange={(e) => set({ digest_hora: e.target.value })}
                disabled={!settings.digest_activo}
                className="input w-36 disabled:opacity-50"
              />
              <span className="text-[11px] text-zinc-500">hora de Monterrey</span>
            </label>
          </div>
        </BloqueSeccion>

        <BloqueSeccion
          titulo="Aviso de casos esperando al cliente"
          descripcion="En días hábiles, a la hora indicada, cada quien recibe un aviso interno de sus casos en Pendiente cliente que llevan uno o más días hábiles esperando. Al cliente no se le manda nada."
        >
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <Toggle
              checked={settings.aviso_cliente_activo}
              onChange={(v) =>
                void alternar(
                  "aviso_cliente_activo",
                  v,
                  v ? "Aviso encendido" : "Aviso apagado",
                )
              }
              label="Avisar de casos esperando al cliente"
            />
            <label className="flex items-center gap-2 text-xs text-zinc-400">
              <span>a las</span>
              <input
                type="time"
                value={valores.aviso_cliente_hora}
                onChange={(e) => set({ aviso_cliente_hora: e.target.value })}
                disabled={!settings.aviso_cliente_activo}
                className="input w-36 disabled:opacity-50"
              />
              <span className="text-[11px] text-zinc-500">hora de Monterrey, solo días hábiles</span>
            </label>
          </div>
          <Toggle
            checked={settings.feriados_mx_activos}
            onChange={(v) =>
              void alternar(
                "feriados_mx_activos",
                v,
                v ? "Los feriados ya no cuentan como día hábil" : "Los feriados vuelven a contar",
              )
            }
            label="Saltar los feriados oficiales de México"
            hint="Además de sábado y domingo, los feriados oficiales tampoco cuentan como día hábil para este aviso."
          />
        </BloqueSeccion>

        <PieGuardar
          sucio={sucio}
          guardando={guardando}
          onGuardar={() => void guardar(valores, "Horarios guardados")}
          textoGuardar="Guardar horarios"
        />
      </div>
    </SeccionLayout>
  );
}
